// Vehicle plate autocomplete source — merges the seeded lookup_values
// list with every distinct plate seen on a bin_loans row or a deliveries
// row. Keeps the bins form's vehicle field useful even though only
// admins can seed lookup_values directly. Read-only, no writes needed.

import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export function useVehicleRegs() {
  return useQuery({
    queryKey: ['vehicle-regs-history'],
    staleTime: 60_000,
    queryFn: async () => {
      const [seeded, loans, deliveries] = await Promise.all([
        supabase.from('lookup_values')
          .select('value').eq('type', 'VEHICLE_REG'),
        supabase.from('bin_loans')
          .select('vehicle_reg')
          .not('vehicle_reg', 'is', null)
          .is('deleted_at', null)
          .order('issued_at', { ascending: false })
          .limit(500),
        supabase.from('deliveries')
          .select('vehicle_reg')
          .not('vehicle_reg', 'is', null)
          .is('deleted_at', null)
          .order('received_at', { ascending: false })
          .limit(500),
      ])
      const set = new Set<string>()
      for (const r of seeded.data ?? [])     set.add(String((r as { value: string }).value).trim().toUpperCase())
      for (const r of loans.data ?? [])      { const v = (r as { vehicle_reg: string | null }).vehicle_reg; if (v) set.add(v.trim().toUpperCase()) }
      for (const r of deliveries.data ?? []) { const v = (r as { vehicle_reg: string | null }).vehicle_reg; if (v) set.add(v.trim().toUpperCase()) }
      return Array.from(set).filter(Boolean).sort()
    },
  })
}
